var version = "9.18.1";

export { version as v };
//# sourceMappingURL=package-b43fd66f.js.map
